




































import { Component, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { Actions, Mutations } from '@/ts/store/Constants';
import CorporationLinkList from '@/components/Admin/Lists/CorporationLinkList.vue';
import ConfirmPopup from '@/components/Admin/Panels/ConfirmPopup.vue';
import CorporationLinkForm from '@/components/Admin/Forms/CorporationLinkForm.vue';

@Component({
    components: {
        CorporationLinkList,
        ConfirmPopup,
        CorporationLinkForm,
    },
    computed: {
        ...mapGetters({
            corporationLinkFormVisibility: 'CorporationLinks/getCorporationLinkFormVisibility',
            confirmPopupVisibility: 'ConfirmPopup/getConfirmPopupVisibility',
        }),
    },
})
export default class CorporationLinks extends Vue {

    public form = {mode: ''};
    constructor() {
        super();
    }

    get adminCorporationLinks() {
        return this.$store.getters['CorporationLinks/getAdminCorporationLinks'];
    }

    public addCorporationLink() {
        this.form.mode = 'add';
        this.$store.commit(Mutations.SET_CORPORATION_LINK_FORM_VISIBILITY, true);
    }

    public beforeCreate() {
        this.$store.dispatch(Actions.FETCH_ALL_LANGUAGES);
    }

    public created() {
        this.$store.dispatch(Actions.FETCH_ALL_CORPORATION_LINKS, { vue: this });
    }

}
